import { AboutHero } from "../Components/AboutHero"

// ABOUT PAGE
// Describes what the project is about and how to use web client


// TODO: Add Content

export const About = () => {

    return(
        <>
            <AboutHero />
        </>
    )
}